<template>
	<div class="pb-5 app">
		<div class="brand-line"></div>
		<main class="container">
			<nuxt />
		</main>
		<div class="container mt-5">
			<div class="col-12 d-flex justify-content-center">
				<a
					href="https://apropos.jobs"
					class="px-3 py-2 border rounded-pill"
					target="_blank"
				>
					<img
						width="150"
						src="/logo-font.png"
						alt="Apropos Jobs Logo"
					/>
				</a>
			</div>
		</div>
		<client-only>
			<CookieBanner @open-settings="showCookieSettings = true" />
			<CookieSettingsModal
				v-if="showCookieSettings"
				@close="showCookieSettings = false"
			/>
		</client-only>

		<PortalTarget name="tooltip-root" multiple />
	</div>
</template>

<script>
import CookieBanner from '~/components/ui/banners/CookieBanner'
import CookieSettingsModal from '~/components/ui/modals/CookieSettingsModal'

export default {
	components: {
		CookieBanner,
		CookieSettingsModal
	},
	data() {
		return {
			showCookieSettings: false
		}
	},
	head() {
		return {
			meta: [
				{ hid: 'robots', name: 'robots', content: 'index, follow' }
			]
		}
	},
	mounted() {
		// Reserved for future functionality
	}
}
</script>
